/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1CourseCourseidLanguagesId202,
  DeleteApiV1CourseCourseidLanguagesId400,
  DeleteApiV1CourseCourseidLanguagesId401,
  DeleteApiV1CourseCourseidLanguagesId404,
  DeleteApiV1CourseCourseidLanguagesId500,
  DeleteApiV1CourseCourseidLanguagesIdMutationResponse,
  DeleteApiV1CourseCourseidLanguagesIdPathParams,
} from "../../types/courseLangsController/DeleteApiV1CourseCourseidLanguagesId.ts";

export const deleteApiV1CourseCourseidLanguagesIdPathParamsSchema = z.object({
  courseId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1CourseCourseidLanguagesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1CourseCourseidLanguagesId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseCourseidLanguagesId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1CourseCourseidLanguagesId400Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseCourseidLanguagesId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1CourseCourseidLanguagesId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseCourseidLanguagesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1CourseCourseidLanguagesId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseCourseidLanguagesId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1CourseCourseidLanguagesId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseCourseidLanguagesId500>;

export const deleteApiV1CourseCourseidLanguagesIdMutationResponseSchema =
  z.lazy(
    () => deleteApiV1CourseCourseidLanguagesId202Schema,
  ) as unknown as ToZod<DeleteApiV1CourseCourseidLanguagesIdMutationResponse>;
